import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Brand } from '../components/Brand'
import { DisplayControls } from '../components/DisplayControls'
import { MarketingPageCanvas } from '../components/marketing/MarketingPageCanvas'
import { useI18n } from '../core/i18n'
import { initialAdSlots, initialFeatureFlags, initialMarketingSections, initialNavigation, initialPageBlocks } from '../data/adminData'
import { loadPublicConfig, mergePlatformConfig } from '../data/platformRepository'
import type { PublicPlatformConfig } from '../types'

export function LandingPage() {
  const { locale } = useI18n()
  const ko = locale === 'ko'
  const [remote, setRemote] = useState<PublicPlatformConfig | null>(null)
  useEffect(() => { const controller = new AbortController(); loadPublicConfig(controller.signal).then(setRemote).catch(() => undefined); return () => controller.abort() }, [])
  const config = mergePlatformConfig(remote, { pageBlocks: initialPageBlocks, navigation: initialNavigation, adSlots: initialAdSlots, featureFlags: initialFeatureFlags })
  const signupEnabled = config.featureFlags.find((flag) => flag.key === 'member_registration')?.enabled !== false
  const storeEnabled = config.featureFlags.find((flag) => flag.key === 'emergency_store')?.enabled === true
  const sections = config.pageSections?.length ? config.pageSections : initialMarketingSections

  return <div className="public-home commercial-home commercial-home-v2">
    <header className="public-home-header">
      <Brand />
      <nav aria-label={ko ? '서비스 안내' : 'Service navigation'}><a href="#how">{ko ? '이용 방법' : 'How it works'}</a><a href="#for-clinics">{ko ? '병원에서 보는 화면' : 'For clinics'}</a><a href="#privacy">{ko ? '기록 보호' : 'Privacy'}</a>{storeEnabled && <Link to="/store">{ko ? '돌봄용품' : 'Supplies'}</Link>}</nav>
      <div className="header-actions"><DisplayControls /><Link className="text-login" to="/member/login">{ko ? '로그인' : 'Sign in'}</Link>{signupEnabled && <Link className="primary-button small" to="/member/signup">{ko ? '무료로 시작' : 'Get started'}</Link>}</div>
    </header>
    <main><MarketingPageCanvas sections={sections} ads={config.adSlots} locale={locale} signupEnabled={signupEnabled} /></main>
    <footer className="public-home-footer"><Brand /><p>{ko ? '병원을 옮겨도 이어지는 반려동물 건강기록' : 'Pet health records that travel between clinics'}</p><span>© 2026 Animal Care | myanimal.care</span></footer>
  </div>
}
